"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveRegionConfig = void 0;

var tslib_1 = require("tslib");

function resolveRegionConfig(input) {
  var region = input.region || input.regionDefaultProvider(input);
  return tslib_1.__assign(tslib_1.__assign({}, input), {
    region: normalizeRegion(region)
  });
}

exports.resolveRegionConfig = resolveRegionConfig;

function normalizeRegion(region) {
  if (typeof region === "string") {
    var promisified_1 = Promise.resolve(region);
    return function () {
      return promisified_1;
    };
  }

  return region;
}